import styled from "styled-components";

export const PageWrapper = styled.section`
  width: 100vw;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  padding: 0 5vw;

  @media only screen and (max-width: 500px) {
    padding: 0;
  }
  &.imprimir,
  .imprimir {
    padding: 2px;
    /* margin-left: 20px; */
    display: block;
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 0 40px;

  @media only screen and (max-width: 500px) {
    padding: 0 20px;
  }
`;

export const PageContent = styled.main`
  margin: 15px 0;
  display: grid;
  grid-template-columns: 80% 20%;
  justify-content: space-between;

  &#naoLogado {
    display: block;
    grid-template-columns: none;
    width: 100%;
  }

  @media only screen and (max-width: 1200px) {
    grid-template-columns: none;
    display: flex;
    flex-direction: column;

    main div.tabela {
      padding: 0 2px;
      overflow-x: scroll;
    }
  }
`;
